import $ from 'jquery';
import ValidatedFormView from '../form/ValidatedFormView.js';

class FormUpdateChild extends ValidatedFormView {
  constructor(options) {
    const validations = {
      ['child[name]']: ['required'],
      ['child[birthday]']: ['required'],
      ['child[gender]']: [{rule: 'radioChecked', param: 'child[gender]'}],
    };
    super(Object.assign({
      formName: 'form-update-child',
      validations: validations,
      onValid: () => {},
    }, options));

    if (!this.$form.length) {
      return;
    }

    this.record = null;

    const params = new URLSearchParams(window.location.search);
    this.identifier = params.get('identifier') || '';
    this.childId = params.get('child') || '';
    this.sig = params.get('sig') || '';

    this.initDeleteButton();

    if (!this.identifier || !this.childId) {
      this.showInvalid();
      return;
    }

    this.loadChild();
  }

  getRoot() {
    return this.$form.closest('[data-update-root]');
  }

  getBasePath() {
    // use first segment of the path to construct the request URL, e.g. "/checklisten-schwangerschaft-geburt"(EF) or "/" if the path is empty (DDEV)
    const firstSegmentMatch = window.location.pathname.match(/^\/[^/]+/);
    return firstSegmentMatch ? firstSegmentMatch[0] : '';
  }

  getRequestUrl() {
    const params = new URLSearchParams({identifier: this.identifier});
    if (this.sig) {
      params.set('sig', this.sig);
    }
    return `${window.location.origin}${this.getBasePath()}/api/newsletter/update?${params.toString()}`;
  }

  loadChild() {
    this.showLoading();

    fetch(this.getRequestUrl(), {
      method: 'GET',
      headers: {'Accept': 'application/json'},
    })
      .then((response) => {
        if (response.status === 404) {
          this.showInvalid();
          return null;
        }
        if (!response.ok) {
          this.showError();
          return null;
        }
        return response.json();
      })
      .then((data) => {
        if (!data) {
          return;
        }

        const child = (data.children || []).find((entry) => String(entry.id) === String(this.childId));

        if (!child) {
          this.showInvalid();
          return;
        }

        this.record = data;
        this.fillForm(child);
        this.showForm();
      })
      .catch(() => {
        this.showError();
      });
  }

  fillForm(child) {
    const gender = (child.gender || '').toLowerCase();

    this.$form.find('[name="child[id]"]').val(child.id);
    this.$form.find('[name="child[name]"]').val(child.name);
    this.$form.find('[name="child[birthday]"]').val(child.birthday);
    this.$form.find(`[name="child[gender]"][value="${gender}"]`).prop('checked', true);
  }

  initDeleteButton() {
    this.getRoot().on('click', '[data-delete-child]', () => {
      $('#modal-confirm-delete-child').modal('show');
    });

    // The confirmation modal lives outside [data-update-root] in the markup, so delegate from
    // the document instead of this.getRoot() - otherwise the click never bubbles to a bound handler.
    $(document).on('click', '[data-confirm-delete-child]', () => {
      this.deleteChild();
    });
  }

  getChildPayloadFromForm() {
    return {
      id: this.childId,
      name: this.$form.find('[name="child[name]"]').val(),
      birthday: this.$form.find('[name="child[birthday]"]').val(),
      gender: this.$form.find('[name="child[gender]"]:checked').val(),
    };
  }

  deleteChild() {
    if (!this.record) {
      return;
    }

    const children = (this.record.children || []).filter((entry) => String(entry.id) !== String(this.childId));
    const payload = {email: this.record.email, children};

    $('#modal-confirm-delete-child').modal('hide');
    this.save(payload, () => this.showDeleted());
  }

  doSubmit(event) {
    event.preventDefault();

    if (!this.record) {
      return;
    }

    const updatedChild = this.getChildPayloadFromForm();
    const children = (this.record.children || []).map((entry) => (
      String(entry.id) === String(this.childId) ? updatedChild : entry
    ));
    const payload = {email: this.record.email, children};

    this.save(payload, () => this.showConfirmation());
  }

  save(payload, onSuccess) {
    const $submitButton = this.$form.find('button[type="submit"]');

    this.hideError();
    $submitButton.prop('disabled', true);

    fetch(this.getRequestUrl(), {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          this.showError();
          return;
        }
        onSuccess();
      })
      .catch(() => {
        this.showError();
      })
      .finally(() => {
        $submitButton.prop('disabled', false);
      });
  }

  showLoading() {
    const $root = this.getRoot();
    $root.find('[data-loading]').attr('hidden', false);
    $root.find('[data-invalid]').attr('hidden', true);
    $root.find('[data-form]').attr('hidden', true);
    $root.find('[data-error]').attr('hidden', true);
  }

  showForm() {
    const $root = this.getRoot();
    $root.find('[data-loading]').attr('hidden', true);
    $root.find('[data-form]').attr('hidden', false);
  }

  showInvalid() {
    const $root = this.getRoot();
    $root.find('[data-loading]').attr('hidden', true);
    $root.find('[data-form]').attr('hidden', true);
    $root.find('[data-invalid]').attr('hidden', false);
  }

  showConfirmation() {
    const $root = this.getRoot();
    $root.find('[data-form]').attr('hidden', true);
    $root.find('[data-confirmation]').attr('hidden', false);
  }

  showDeleted() {
    const $root = this.getRoot();
    $root.find('[data-form]').attr('hidden', true);
    $root.find('[data-deleted]').attr('hidden', false);
  }

  showError() {
    this.getRoot().find('[data-error]').attr('hidden', false);
  }

  hideError() {
    this.getRoot().find('[data-error]').attr('hidden', true);
  }
}

export default FormUpdateChild;
